import React from 'react';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { GlobalContextProvider } from './context/global/GlobalProvider';
import { AuthContextProvider } from './context/auth/AuthProvider';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Router>
      <GlobalContextProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </GlobalContextProvider>
    </Router>
  </React.StrictMode>,
);
